<script>
  export default {
      name: "Facedetectsection"
  }
</script>

<template>
  <div class="row boletos-section">
    <div class="container">
      <section class="section">
        <div class="text-boletos">
          <h2>
            <span class="title-boletos">Transforme sua audiência em doadores</span>
          </h2>
          <p>
            Você pode transformar seguidores das redes sociais e  listas de contatos em doadores, integrando seu Voto Legal com o JUNTOS.
          </p>
          <p>
            Veja como funciona.
          </p>
          <a
            class="call-to-action-button"
            target="_blank"
            href="https://juntos.digital/"
          >
            Conheça agora
          </a>
        </div>

        <img
          class="img-authenticity"
          src="../../img/integration/integration.svg"
          alt="Integração votolegal"
        >
      </section>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.call-to-action-button {
  margin-top: 1rem;
  display: inline-block;
  padding: 0.6rem 2rem;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-size: 1em;
  font-weight: 600;
  border: 2px solid #fff;
  border-radius: 8px;
  background-color: transparent;
}

  .boletos-section {
      background-color: #119783
  }

  .boletos-section .section {
    align-items: center;
    flex-wrap: wrap;
  }

  .section {
      overflow: hidden;
  }

  @media screen and (min-width: 768px) {
      .text-boletos {
          float: left;
          width: 50%;
      }
  }

  .title-boletos {
      color: #ffffff;
  }

  .text-boletos p {
    font-size: 18px;
    line-height: 2;
    color: #ffffff;

    @media (max-width: 913px) {
      margin-bottom: 2em;
    }
  }

  .img-authenticity {
      margin-left: auto;
      margin-right: auto;
      display: block;
      width: 100%;

      @media (min-width: 768px) {
        width: 50%;
      }
  }

  .call-to-action {
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    color: #fff;
    text-transform: lowercase;
    text-decoration: underline;

    cursor: pointer;
    position: relative;

    &:hover{
      color: rgb(51, 204, 102);
    }
  }
</style>



// WEBPACK FOOTER //
// _source/javascript/components/facedetectsection.vue